import { type AntiForgeryTokenInfo, type ViewModel } from "../ApiClients";

declare global {
  interface Window {
    initialState: ViewModel;
    epostRegex: RegExp;
  }
}

const initial = window.initialState;
export const froala = initial.froalaLicense ?? "";
export const sentry = initial.sentryId ?? undefined;
export const matomoId = initial.matomoTagManager ?? undefined;
export const {
  texts,
  footer,
  personvernerklaering,
  features,
  version,
  logoUrl,
} = initial;
export const urls = {
  lastNedUttalelse: (eksternId: string | number) =>
    initial.urls.lastNedUttalelse.replace("eksternId", eksternId.toString()),
  lastNedSpørsmålUttalelseVedlegg: (eksternId: string | number) =>
    initial.urls.lastNedSpørsmålUttalelseVedlegg.replace(
      "eksternId",
      eksternId.toString(),
    ),
  lastNedUtkastUrl: (eksternId: string | number) =>
    initial.urls.lastNedUtkastUrl.replace("eksternId", eksternId.toString()),
  lastNedVedlegg: (id: string | number) =>
    initial.urls.lastNedVedlegg.replace("id", id.toString()),
};

export const institusjonNavnLang = initial.institusjonNavnLang!;
export const getAntiForgeryTokenInfo = (): AntiForgeryTokenInfo =>
  window.initialState.antiForgeryTokenInfo!;
